import { useCallback } from 'react';

import { actionsFactory, componentsFactory } from '../factories';
import type { SharingModalProps } from '../types';

type HookReturnType = {
	data: ReturnType<typeof componentsFactory>;
	actions: ReturnType<typeof actionsFactory>;
};

export function useSharingModal(props: SharingModalProps): HookReturnType {
	const components = useCallback(() => {
		return componentsFactory(props);
	}, [props]);

	const actions = useCallback(() => {
		return actionsFactory(props);
	}, [props]);

	return {
		data: {
			...components(),
		},
		actions: {
			...actions(),
		},
	};
}
